/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type { TokenAdditionListResponse, TokenUsageResponse } from './model';
import { TenantBillingPeriodTypeSchema, TenantPlanTypeSchema } from './model';

export const getGetTokenUsageResponseMock = (
  overrideResponse: Partial<TokenUsageResponse> = {},
): TokenUsageResponse => ({
  plan: {
    type: faker.helpers.arrayElement(Object.values(TenantPlanTypeSchema)),
    name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    billing_period_type: faker.helpers.arrayElement(Object.values(TenantBillingPeriodTypeSchema)),
  },
  billing_period: {
    start_date: faker.date.past().toISOString().split('T')[0],
    end_date: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.date.past().toISOString().split('T')[0], null]),
      undefined,
    ]),
  },
  contract_period: {
    start_date: faker.date.past().toISOString().split('T')[0],
    end_date: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.date.past().toISOString().split('T')[0], null]),
      undefined,
    ]),
  },
  weighted_tokens: {
    limit_tokens: faker.number.int({ min: undefined, max: undefined }),
    used_input_tokens: faker.number.int({ min: undefined, max: undefined }),
    used_output_tokens: faker.number.int({ min: undefined, max: undefined }),
    used_tokens: faker.number.int({ min: undefined, max: undefined }),
    usage_percentage: faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    is_limit_exceeded: faker.datatype.boolean(),
  },
  ...overrideResponse,
});

export const getListTokenAdditionsResponseMock = (): TokenAdditionListResponse => ({
  items: [
    {
      id: '990e8400-e29b-41d4-a716-446655440001',
      start_date: '2026-04-10',
      total_tokens: 29411764,
      used_tokens: 750,
      remaining_tokens: 29411014,
    },
    {
      id: '990e8400-e29b-41d4-a716-446655440002',
      start_date: '2026-03-01',
      total_tokens: 17647058,
      used_tokens: 1200,
      remaining_tokens: 17645858,
    },
  ],
});

export const getGetTokenUsageMockHandler = (
  overrideResponse?:
    | TokenUsageResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TokenUsageResponse> | TokenUsageResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/ai-logs/token-usage',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetTokenUsageResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListTokenAdditionsMockHandler = (
  overrideResponse?:
    | TokenAdditionListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TokenAdditionListResponse> | TokenAdditionListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/ai-logs/token-additions',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListTokenAdditionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetTokenUsageMockHandler(),
  getListTokenAdditionsMockHandler(),
];
